'use strict';
const angular = require('angular');
const {isArray, isObject} = angular;

//DomainFilter
export const excludeDomainImport = [
  excludeDomain];

function excludeDomain() {
  return function (list, query) {
    if (!query && !isArray(query) && !isObject(query)) return list;

    return filter(list, createFilter(query));
  }
}

function filter (map, filter) {
  var itemKey, copy = {};

  for (itemKey in map) {
    if (map.hasOwnProperty(itemKey) && !filter.hasOwnProperty(itemKey)) {
      copy[itemKey] = map[itemKey];
    }
  }

  return copy;
}

function createFilter (query) {
  var item, result = {};

  if (isObject(query) && !isArray(query)) return query;

  for (var i = 0; i < query.length; i++) {
    item = query[i];

    if (item && isObject(item) && item.$id) {
      result[item.$id] = true;
    }
  }

  return result;
}


// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/excludeDomain.js